module.exports = __webpack_public_path__ + "static/media/bg-mural.1f73b95e.jpg";